import React from 'react';
import useDialogConfig from '../_hooks/useDialogConfig';
import FiltersStoryDialog from '../../dialogs/filters.stories';
import useDialogRouter from '../_hooks/useDialogRouter';
import usePageRouter from '../_hooks/usePageRouter';

export default function Launcher(props) {
  const config = useDialogConfig();

  const router = config.params.parentDialogId ?
    useDialogRouter(config.params.parentDialogId) :
    usePageRouter();

  return (
    <FiltersStoryDialog
      router={router}
      onCancel={props.onClose}
    />
  );
};
